import { Article } from "./Article";

export interface ArticleResponse {
  totalRecords: number | null;
  currentPage: number | null;
  totalPages: number | null;
  pageSize: number | null;
  data: Article[];
}

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:7845'; // backend Express

export async function fetchArticles(params: {
  ArtNo?: string;
  Name?: string;
  Status?: string;
  ClauseNo?: string;
  page: number;
  limit: number;
  sortBy?: string;
  order?: "asc" | "desc";
}): Promise<ArticleResponse> {
  const query = new URLSearchParams();

  // only append params if they exist and are not empty
  if (params.ArtNo) query.append("ArtNo", params.ArtNo);
  if (params.Name) query.append("Name", params.Name);
  if (params.Status) query.append("Status", params.Status);
  if (params.ClauseNo) query.append("ClauseNo", params.ClauseNo);
  if (params.sortBy) query.append("sortBy", params.sortBy);
  if (params.order) query.append("order", params.order);

  // pagination (always required)
  query.append("page", params.page.toString());
  query.append("limit", params.limit.toString());

  const res = await fetch(`${API_URL}/api/articles?${query.toString()}`);

  if (!res.ok) {
    throw new Error("Failed to fetch articles");
  }

  return res.json();
}